import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { firstUserErrorCode } from '@/graphql/errors';
import { RESEND_SIGN_IN_LINK } from '@/graphql/mutations/auth';
import type { RequestSignInLinkOutcome } from './use-request-sign-in-link';

type UseResendSignInLinkResult = {
  resendSignInLink: (linkId: string) => Promise<RequestSignInLinkOutcome>;
  isResending: boolean;
};

export function useResendSignInLink(): UseResendSignInLinkResult {
  const [mutate, { loading }] = useMutation(RESEND_SIGN_IN_LINK);

  const resendSignInLink = useCallback(
    async (linkId: string): Promise<RequestSignInLinkOutcome> => {
      const { data } = await mutate({ variables: { input: { linkId } } });
      const payload = data?.resendSignInLink;
      if (payload?.link) return { link: payload.link, errorCode: null };
      return { link: null, errorCode: firstUserErrorCode(payload?.userErrors) ?? 'UNKNOWN' };
    },
    [mutate],
  );

  return { resendSignInLink, isResending: loading };
}
